































































import Vue from "vue";
// import FacebookShareLink from "@/components/social/FacebookShareLink.vue";
// import TwitterShareLink from "@/components/social/TwitterShareLink.vue";
// import SMSShareLink from "@/components/social/SMSShareLink.vue";
import MobileShareSheet from "@/components/MobileShareSheet.vue";
import { PropOptions } from "vue/types/umd";
import { CustomPageMeta } from "../interfaces/CustomPageMeta";
import { Page } from "../interfaces/Page";

export default Vue.extend({
  props: {
    // The page metadata for this share image
    page: {
      type: Object,
      required: true
    } as PropOptions<CustomPageMeta & Page>,
    shareText: {
      type: String,
      required: true
    }
  },
  components: { MobileShareSheet },
  computed: {
    // shareText(): string {
    //   return "This is some placeholder share text for " + this.page.name;
    // },
    siteBase(): string {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const s: string = process.env.VUE_APP_SITE_URL!;
      return s.substr(0, s.length - 1);
    },
    shareURL(): string {
      return `${this.siteBase}${this.$route.path}`;
    }
  },
  methods: {
    onShare(type: string) {
      this.$gtag.event(`${type} Share Click`, {
        // eslint-disable-next-line @typescript-eslint/camelcase
        event_category: "Social Share"
      });
    }
  }
});
